import {
  Box,
  FormControl,
  IconButton,
  Select,
  styled,
  Typography,
} from '@mui/material';

export const TableDataName = styled(Typography)(() => ({
  color: '#1a1a1a',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '140%',
}));

export const AmountOFClients = styled(Typography)(() => ({
  color: '#475467',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '140%',
}));

export const FilterAndSearchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',

  padding: '32px 0',
  gap: '24px',

  [theme.breakpoints.down('xl')]: {
    gap: '12px',
  },
}));

export const FilterContainer = styled(FormControl)(({ theme }) => ({
  '& .MuiInputLabel-root': {
    color: theme.palette.secondary.main,
  },

  '& .MuiFormLabel-root': {
    background: '#FFF',
    paddingRight: '4px',
  },
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  width: '258px',
  borderRadius: '30px',
  display: 'flex',
  alignItems: 'center',

  '& .MuiSelect-outlined': {
    '& .Mui-focused': {
      border: `1px solid ${theme.palette.secondary.main}`,
    },
  },
  '& + . MuiModal-backdrop': {
    display: 'none !important',
  },

  '.MuiFormLabel-root': {
    background: 'red',
  },

  [theme.breakpoints.down('xl')]: {
    width: '206px',
    fontSize: '14px',
  },

  [theme.breakpoints.up('xl')]: {
    width: '258px',
  },
}));

export const ChipFiltersContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isVisible',
})<{ isVisible?: boolean }>(({ theme, isVisible = false }) => ({
  display: isVisible ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '16px 8px 42px 8px',
  width: '85%',

  '> button': {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  [theme.breakpoints.down('xl')]: {
    width: '100%',
  },
}));

export const StyledChip = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.dark,
  color: theme.palette.common.white,
  fontSize: '14px',
  lineHeight: '140%',
  borderRadius: '4px',
  padding: '8px',

  [theme.breakpoints.down('xl')]: {
    fontSize: '12px',
  },
}));

export const DeleteFilterButton = styled(IconButton)(({ theme }) => ({
  width: '24px',
  height: '24px',
  marginLeft: '4px',

  color: theme.palette.common.white,

  '&:hover': {
    color: theme.palette.primary.main,
  },
}));
